export default __webpack_public_path__ + "static/media/logo-icon.9e93e8fe.png";